import script from "./DescriptionField.vue?vue&type=script&setup=true&lang=js"
export * from "./DescriptionField.vue?vue&type=script&setup=true&lang=js"

import "./DescriptionField.vue?vue&type=style&index=0&id=377be404&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-377be404"]])

export default __exports__